import { formatToCurrency } from "@shared/utils/formatters";
import {
  Card,
  ProductInfo,
  ProductNameContainer,
  Price,
  ProductDescription,
  TotalInfo,
  TotalItem,
} from "./styles";
import { FreeSubscriptionBreakdownProps } from "./SubscriptionBreakdown.types";
import { Divider, Typography } from "@mui/material";

export const FreeSubscriptionBreakdown = (
  props: Omit<FreeSubscriptionBreakdownProps, "type">
) => {
  const { productName, productDescription } = props;

  return (
    <Card>
      <ProductInfo>
        <ProductNameContainer>
          <Typography>{productName}</Typography>
        </ProductNameContainer>
        {!!productDescription && (
          <ProductDescription>{productDescription}</ProductDescription>
        )}
      </ProductInfo>
      <Divider sx={{ margin: "0rem 1rem 0.5rem 1rem" }} />

      <TotalInfo>
        <TotalItem>
          <Typography fontWeight={500}>Billing monthly</Typography>
          <Price>
            <span data-testid="offer-price-after-discount">
              {formatToCurrency(0)}
            </span>
          </Price>
        </TotalItem>
      </TotalInfo>
    </Card>
  );
};
